import React from 'react';
import { ServicesSection } from '../components/ServicesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
export function About() {
  return <div data-id="element-865">
      <ServicesSection data-id="element-866" />
      <TestimonialsSection data-id="element-867" />
    </div>;
}